import { useEffect, useState } from 'react';
import { matchPath, useHistory, useLocation } from 'react-router-dom';
import {
  LeftNavigation,
  LeftNavigationBody,
  LeftNavigationHeader,
} from '@tag/tag-components-react-v4';

import { MenuItem, menuItems } from '@/config/navigation.config';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { NavItem } from './components/NavItem';
import { useGetUserRole } from '@/hooks/identity/useGetUserRole';
import { UserRole } from '@/config/roles.config';

const DEFAULT_NAV_ACTIVE_ITEM = '/';

export default function LeftSidebar() {
  const RouterHistory = useHistory();
  const { pathname } = useLocation();
  const { getUserRole } = useGetUserRole();
  const [userRole, setUserRole] = useState<UserRole>();
  const [selectedNavItem, setSelectedNavItem] = useState<string>(
    DEFAULT_NAV_ACTIVE_ITEM
  );
  const defaultCollapsed = JSON.parse(
    window?.localStorage?.getItem('isSidebarCollapsed') || 'false'
  );
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const menuItemLinks = menuItems.reduce(
    (menuLinks: string[], menuItem: MenuItem) => {
      if (menuItem.children) {
        menuItem.children.forEach((subItem) => {
          if (subItem.children) {
            return subItem.children.forEach(
              (item) => item.link && menuLinks.push(item.link)
            );
          } else {
            return subItem.link && menuLinks.push(subItem.link);
          }
        });
      }
      if (menuItem.link) {
        menuLinks.push(menuItem.link);
      }

      return menuLinks;
    },
    []
  );

  useEffect(() => {
    const getRole = async () => {
      const roleName = await getUserRole();
      setUserRole(roleName);
    };

    getRole();
  }, [getUserRole]);

  useEffect(() => {
    const isMatchFound = matchPath(pathname, {
      path: menuItemLinks,
      exact: true,
    });
    if (isMatchFound) {
      setSelectedNavItem(isMatchFound.path);
    } else {
      setSelectedNavItem('');
    }
  }, [menuItemLinks, pathname]);

  const onSideNavCollapsedChange = (collapsedMenu: boolean) => {
    window?.localStorage?.setItem('isSidebarCollapsed', String(collapsedMenu));
    setCollapsed(collapsedMenu);
  };

  const onSideNavItemSelected = (itemName?: string) => {
    const getActiveItemAndRedirect = (items: MenuItem[]) => {
      items.forEach((menuItem) => {
        if (menuItem.children) {
          const activeSubItem = menuItem.children.find((subItem) => {
            if (subItem.children) {
              return getActiveItemAndRedirect(subItem.children);
            } else {
              return subItem.link === itemName;
            }
          });
          if (activeSubItem && activeSubItem.link) {
            RouterHistory.push(getParameterizedLink(activeSubItem.link));
            return activeSubItem;
          }
        }

        if (menuItem.link && menuItem.link === itemName) {
          RouterHistory.push(getParameterizedLink(menuItem.link));
          return;
        }
        return null;
      });
    };
    getActiveItemAndRedirect(menuItems);

    setSelectedNavItem(itemName ?? DEFAULT_NAV_ACTIVE_ITEM);
  };

  return (
    <div className='d-flex mt-40' style={{ height: 'calc(100vh - 40px)', flexShrink: 0 }}>
      <LeftNavigation
        onCollapsedChange={onSideNavCollapsedChange}
        collapsed={collapsed}
        collapsable={true}
        accent='teal'
        style={{ zIndex: 1 }}
        selectedItem={selectedNavItem}
        onSelectedItemChange={onSideNavItemSelected}
      >
        <LeftNavigationHeader>
          <span style={{ color: '#fff' }}>Menu</span>
        </LeftNavigationHeader>
        <LeftNavigationBody>
          {menuItems.map((item) => (
            <NavItem key={item.text} item={item} userRole={userRole} selectedNavItem={selectedNavItem} />
          ))}
        </LeftNavigationBody>
      </LeftNavigation>
    </div>
  );
}
